import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import RadioGroup from './form/radio-group';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.offers = {
            3: {
                tid: 'UAUIMTYJ',
                long_label: '3 Minutes Free',
                short_label: '3 Min',
            },
            10: {
                tid: 'CRQEUHSO',
                long_label: '10 Minutes $1.99',
                short_label: '10 Min',
            },
        };

        props.init({
            size: props.size || 1,
            offer: props.mode && props.mode == 'full-width' ? this.offers[10].tid : null,
        });

        this.state = {
            offer: props.mode && props.mode == 'full-width' ? this.offers[10].tid : null,
        };

        props.trackEvent([
            'Psychics',
            `${props.logged_in ? 'LI' : 'LO'} Impression`,
            'Keen-API',
        ]);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.keen != this.props.keen) {
            return true;
        } else if (nextState.offer != this.state.offer) {
            return true;
        }

        return false;
    }

    render({ keen, mode }) {
        if (Object.keys(keen).length) {
            return (
                <keen mode={mode}>
                    <row className='is-wrap'>
                        {this.renderOffers()}
                        {Object.keys(keen).map(key => this.renderAdvisor(keen[key]))}
                    </row>
                </keen>
            );
        }

        return (<keen {...this.props} />);
    }

    renderOffers = () => {
        if (this.props.mode && this.props.mode == 'full-width') {
            /* eslint-disable max-len */
            return [
                <column className='is-6 has-text-right-desktop has-text-right-tablet has-text-center-mobile has-padding-10-right-desktop has-padding-10-right-tablet has-padding-20-bottom-desktop has-padding-20-bottom-tablet has-padding-10-bottom-mobile'>
                    <RadioGroup
                        name='offer'
                        value={this.offers[3].tid}
                        label={this.offers[3].long_label}
                        checked={this.state.offer == this.offers[3].tid}
                        onChange={this.updateOffer}
                    />
                </column>,
                <column className='is-6 has-text-center-mobile has-padding-10-left-desktop has-padding-10-left-tablet has-padding-20-bottom-desktop has-padding-20-bottom-tablet has-padding-10-bottom-mobile'>
                    <RadioGroup
                        name='offer'
                        value={this.offers[10].tid}
                        label={this.offers[10].long_label}
                        checked={this.state.offer == this.offers[10].tid}
                        onChange={this.updateOffer}
                    />
                </column>,
            ];
            /* eslint-enable max-len */
        }

        return null;
    }

    renderAdvisor = (advisor) => {
        if (this.props.mode && this.props.mode == 'full-width') {
            const advisorUrl = `https://keen.com${advisor.detailsUrl}&pmode=1&tid=${this.state.offer}`;

            return (
                <column className='is-6 is-12-mobile has-padding-10 has-padding-40-bottom-mobile'>
                    <a href={advisorUrl} target='_blank' rel='noopener'>
                        <row className='has-margin-20-bottom-desktop has-margin-20-bottom-tablet'>
                            <column className='is-4 is-5-mobile'>
                                <img className='lazyload'
                                    data-src={advisor.pictureURL}
                                    alt={advisor.name}
                                    height='175'
                                    width='175'
                                />
                            </column>
                            <column className='is-8 is-7-mobile has-padding-20-left'>
                                {this.renderAvailability(advisor.chatAvailability)}
                                <h3 className='has-margin-5-top'>{advisor.name}</h3>
                                <p>{advisor.listingTitle}</p>
                                <a
                                    className='button button-pink-alternate is-hidden-mobile'
                                    href={advisorUrl}
                                    target='_blank'
                                    rel='noopener'
                                    onClick={this.trackClick}
                                >Connect to Advisor</a>
                            </column>
                        </row>
                        <row className='is-visible-mobile'>
                            <column className='is-12'>
                                <a
                                    className='button button-pink-alternate is-block'
                                    href={advisorUrl}
                                    target='_blank'
                                    rel='noopener'
                                    onClick={this.trackClick}
                                >Connect to Advisor</a>
                            </column>
                        </row>
                    </a>
                </column>
            );
        } else if (this.props.mode && this.props.mode == 'in-page') {
            const advisorUrl = 'https://www.keen.com/psychic-readings/195?tid=V3LTBSLU';

            /* eslint-disable max-len */
            return (
                <column className='is-12'>
                    <a
                        href={advisorUrl}
                        target='_blank'
                        rel='noopener'
                        className='is-block'
                        onClick={this.trackClick}
                    >
                        <row className='is-aligned-center'>
                            <column className='has-padding-20-right'>
                                <h2 className='is-h1 fancy-title has-margin-20-bottom has-margin-10-bottom-mobile'>
                                    Free Insight
                                </h2>
                            </column>
                            <column>
                                {this.renderAvailability(advisor.chatAvailability)}
                            </column>
                        </row>
                        <row className='is-wrap'>
                            <column
                                className='is-3 is-4-tablet is-5-mobile has-padding-20-right has-padding-40-right-desktop'
                            >
                                <img className='lazyload' height='175' width='175' data-src={advisor.pictureURL} alt={advisor.name} />
                            </column>
                            <column className='is-9 is-8-tablet is-7-mobile'>
                                <h3 className='has-margin-20-bottom has-line-height-24'>{advisor.name}</h3>
                                <p>Chat or talk with an experienced spiritual advisor now!</p>
                                <a
                                    className='button button-pink is-hidden-mobile'
                                    href={advisorUrl}
                                    target='_blank'
                                    rel='noopener'
                                >
                                    Get FREE Live Insight Now
                                </a>
                            </column>
                            <column className='is-12 is-visible-mobile has-text-center'>
                                <a
                                    className='button button-pink'
                                    href={advisorUrl}
                                    target='_blank'
                                    rel='noopener'
                                >
                                    Get FREE Live Insight Now
                                </a>
                            </column>
                        </row>
                    </a>
                </column>
            );
            /* eslint-enable max-len */
        }

        return null;
    }

    renderAvailability = (availability) => {
        if (availability !== 0) {
            return (
                <row className='is-aligned-center has-text-shamrock'>
                    <column
                        className='has-text-size-42 has-line-height-0 has-margin-10-bottom has-padding-5-right'
                    >&bull;</column>
                    <column className='has-text-size-17'>Online Now</column>
                </row>
            );
        }

        return null;
    }

    updateOffer = (e) => {
        this.setState({ offer: e.target.value });

        this.props.init({
            size: this.props.size || 1,
            offer: this.state.offer,
        });
    }

    trackClick = () => {
        let label = 'Keen-API';

        if (this.props.mode && this.props.mode == 'full-width' && this.state.offer) {
            Object.keys(this.offers).forEach(key => {
                const offer = this.offers[key];

                if (offer.tid == this.state.offer) {
                    label = `${label}:${offer.short_label}`;
                }
            });
        }

        this.props.trackEvent([
            'Psychics',
            `${this.props.logged_in ? 'LI' : 'LO'} Click`,
            label,
        ]);
    }
}

const mapStateToProps = (state) => ({
    keen: state.keen,
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    init: (payload) => dispatch({ type: 'keen:init', payload: payload }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);